import { render, staticRenderFns } from "./DefinitionList.vue?vue&type=template&id=577ad10c&"
import script from "./DefinitionList.vue?vue&type=script&lang=js&"
export * from "./DefinitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports